import api from 'utils/api';
import { BASE_API_URL } from 'api/constants';

export const getCustomerPortalUrl = async () => {
  return api.get(`${BASE_API_URL}/get_customer_portal_url/`).then((response) => response?.data?.url);
};
